import Vue from 'vue'
import axios from "axios"
import api from '../api'

export const state = {
  clienti: []
}

export const getters = {

  clientiFiltrati: (state) => ({ search, sortKey, sortOrder }) => {

    let list = state.clienti

    if (search) {
      const searchLower = search.toLowerCase()

      list = list.filter(client =>
        (client.nume && client.nume.toLowerCase().includes(searchLower)) ||
        (client.telefon && client.telefon.includes(searchLower)) ||
        (client.numeFirma && client.numeFirma.toLowerCase().includes(searchLower))
      )
    }

    list = [...list].sort((a, b) => {

      const aVal = a[sortKey]
      const bVal = b[sortKey]

      if (!aVal || !bVal) return 0

      if (sortOrder === 'asc') {
        return aVal > bVal ? 1 : -1
      }

      return aVal < bVal ? 1 : -1
    })

    return list

  }

}

export const actions = {
  async get_clienti ({ commit }, search = '') {
    try {
      const { data } = await axios({
        url: api.get_clienti,
        params: search ? { search } : {}
      })
      commit('SET_CLIENTI', data)
      // eslint-disable-next-line no-empty
    } catch (e) {}
  },

  async delete_client ({ commit }, client) {
    try {
      await axios.delete(`${api.get_clienti}/${client._id}`)
      commit('DELETE_CLIENT', client._id)
    } catch (e) {}
  },

  async create_client (_ctx, client) {
    try {
      const { data } = await axios.post(api.get_clienti, client)
      return data
    } catch (e) {
      this._vm?.$toast?.error?.('Nu s-a putut salva clientul. Încearcă din nou.')
      return false
    }
  },

  async scan_id_card (_ctx, file) {
    const formData = new FormData()
    formData.append('id_card', file)
    const { data } = await axios.post(api.scan_id_card, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return data
  },

  async update_client (_ctx, client) {
    try {
      const { data } = await axios.put(`${api.get_clienti}/${client._id}`, client)
      return data
    } catch (e) {
      this._vm?.$toast?.error?.('Nu s-a putut salva clientul. Încearcă din nou.')
      return false
    }
  },

}

export const mutations = {
  SET_CLIENTI (state, clienti) {
    Vue.set(state, 'clienti', clienti)
  },

  DELETE_CLIENT (state, id) {
    const index = state.clienti.findIndex(c => c._id === id)
    if (index !== -1) state.clienti.splice(index, 1)
  },

}
